import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { queryKeys, requestCCApi } from 'src/utils';

export const useUpdateComponentTag = () => {
  return useMutation({
    mutationFn: updateComponentTag,
    onSuccess() {
      queryClient.invalidateQueries(queryKeys.componentTags.invalidateAll());
      queryClient.invalidateQueries(
        queryKeys.viewComponentTagWithComponentCount.invalidateAll(),
      );
    },
  });
};

const updateComponentTag = async (payload: {
  componentTagId: string;
  componentTag: string;
}) => {
  const request = {
    name: payload.componentTag,
  };

  const response = await requestCCApi({
    url: `/componentTags/${payload.componentTagId}`,
    method: 'PUT',
    data: { data: request },
  });

  return response;
};
